import React from 'react';

const InputContainer = ({
  children, backgroundColor, style, className, error,
}) => (
  <div
    className={`flex w-full border ${error ? "border-critical" : "border-gray-400"} rounded-btn px-4 py-2 ${className}`}
    style={{
      backgroundColor,
      ...style,
    }}
  >
    {children}
  </div>
);

InputContainer.defaultProps = {
  backgroundColor: '',
  className: '',
  style: {},
};

export default InputContainer;
